import { CountryCode, getCurrencyByCountry, getLocationService } from '@guiker/base-entity'
import { selectFromMap } from '@guiker/lodash'
import { Building } from '@guiker/real-estate-shared'
import { ValueOf } from '@guiker/ts-utils'

import { InvestmentAssumptions } from '../entity'

export const defaultCostsBuilder = (building: Building) => {
  const { city, state, country } = getLocationService().getCityBySlug(building.address.city)
  const citySlug = `${city.slug}-${state.stateCode.toLowerCase()}`
  const currency = getCurrencyByCountry(country.countryCode as CountryCode)

  return {
    currency,
    citySlug,
    buildPurchaseCosts: (args: InvestmentAssumptions.CostArgs) => {
      const selectCost = selectFromMap<ValueOf<InvestmentAssumptions.PurchaseConfiguration>>({
        ...InvestmentAssumptions.buildPurchaseConfiguration(args),
        default: undefined,
      })
      return selectCost(citySlug) ?? selectCost(currency.iso)
    },
    buildOperationCosts: () => {
      const selectCost = selectFromMap<ValueOf<typeof InvestmentAssumptions.OperationConfiguration>>({
        ...InvestmentAssumptions.OperationConfiguration,
        default: undefined,
      })
      return selectCost(citySlug) ?? selectCost(currency.iso)
    },
  }
}
